import {
  makeAutoObservable,
  observable,
  action,
  computed,
  runInAction,
  toJS,
  autorun,
  onBecomeUnobserved,
  reaction,
} from "mobx";
import { commonAxios } from "../../pages/ExperianPage/CommonAxios";
class TopNavBarStore {
  constructor(rootstore) {
    this.rootstore = rootstore;
    makeAutoObservable(this);
  }

}

export default TopNavBarStore;
